<template>

  <el-row :gutter="5">
    <el-col :span="8"></el-col>
    <el-col :span="8"><h2 class="heading">My Personal Investment List</h2></el-col>
    <el-col :span="8">
        <el-button v-if="global.hasRight('personal-investment', 'approver')" 
            style="margin-top:20px;" @click="$router.push('/investment/allInvestmentList')">
            <el-icon><Search/></el-icon> &nbsp; All Personal Investments</el-button>
        <el-button style="margin-top:20px; margin-left:20px;" @click="$router.push('/investment/editInvestment')" >
            <el-icon><Plus/></el-icon> &nbsp; Add Personal Investment</el-button>
    </el-col>
  </el-row>

  <el-table :data="investmentList" height="88%" style="width:95%; margin:15px auto;" :row-class-name="tableRowClassName"
        :default-sort="{ prop: prop, order: order }" @sort-change="sortChange">
    <el-table-column prop="id" label="No" align="center" width="60" sortable="custom" />
    <el-table-column prop="title" label="Title" width="300" sortable="custom" />
    <el-table-column prop="fullname" label="Creator" />
    <el-table-column prop="createDate" label="Create Time" width="140" sortable="custom"/>
    <el-table-column prop="status" label="Status" align="center" sortable="custom"/>
    <el-table-column prop="applyApprove" label="Need Approval" align="center" sortable="custom"/>
    <el-table-column prop="status" label="Action" align="center">
        <template #default="scope">
            <a href="" v-if="scope.row.status == 'pending' && global.hasRight('personal-investment', 'approver')" 
                @click.prevent="$router.push('/investment/viewInvestment?code=' + scope.row.idMd5)" title="Approve" class="op">
                    Approve
            </a>
            <a href="" v-if="scope.row.status == 'pending' && scope.row.creator == global.currentUser.id" 
                @click.prevent="$router.push('/investment/editInvestment?code=' + scope.row.idMd5)" title="Edit" class="op">
                    Edit
            </a>
            <el-icon :size="16" v-if="scope.row.status == 'pending' && scope.row.creator == global.currentUser.id" 
                @click="deleteInvestment(scope.row.idMd5)" title="Delete" class="op">
                    <Delete/>
            </el-icon>
            <el-icon :size="16" @click="$router.push('/investment/viewInvestment?code=' + scope.row.idMd5)" title="View details" class="op">
                <document />
            </el-icon>
        </template>
    </el-table-column>
  </el-table>
  <el-pagination background layout="prev, pager, next" :total="page.rowCount" :page-size="page.pageSize" :current-page="page.currPage"
    @current-change="getInvestmentList" style="justify-content: center;"></el-pagination>

</template>

<script>

import AXIOS from '@/common/axios.js'
import global from '@/common/global.js'
import { ElMessage, ElMessageBox } from 'element-plus'
import { Document, Search, Plus, Delete, CircleCheckFilled, CircleCheck } from '@element-plus/icons-vue'

export default {
    components: {
        Document, Search, Plus, Delete, CircleCheckFilled, CircleCheck
    },
    data() {
        return {
            orderObj : {prop: "id", order: "descending"},
            investmentList: [],
            page: {currPage: 1},
            global,
        }
    },
    async mounted() {
        this.global.index = "investment";
        this.getInvestmentList(1);
    },
    methods: {
        deleteInvestment(code) {
            ElMessageBox.confirm(
                'Are you sure want to delete this personal investment?',  'Warning',
                { cancelButtonText: ' No ', confirmButtonText: ' Yes ', type: 'warning', }
            ).then(async () => {
                let result = await AXIOS("/investment/deleteInvestment", {code:code});
                if (result.success) {
                    this.investmentList.splice(this.investmentList.findIndex(e => e.idMd5 == code), 1);
                    ElMessage({
                        message: 'Deleted personal investment successfully!',
                        type: 'success',
                    });
                }
            })
        },
        sortChange(orderObj) {
            this.orderObj = orderObj;
            this.getInvestmentList(1);
        },
        async getInvestmentList(pageNo) {
            this.page.currPage = pageNo;
            let data = {pageNo: pageNo};
            if (this.orderObj.prop) {
                data["prop"] = this.orderObj.prop;
                data["order"] = this.orderObj.order;
            }

            let result = await AXIOS("/investment/myInvestmentList", data);
            if (result.success) {
                this.investmentList = result.data.list;
                this.page = result.data.page;
            }
        },
        tableRowClassName(scope) {
            return (scope.row.status == "approved" || scope.row.status == "rejected") ? "" : scope.row.status;
        }
    }
}
</script>

<style>
</style>